import React from 'react';
import { ContactNavigationContext, usePeopleMassLinkUseCase } from 'features/tasks-forms';
import { Button, ButtonColor, ButtonSize } from 'ui-builder';
import { FubIntegrationToggleWrapper } from 'feature-toggle';
import usePeopleNavigator from '../../peopleNavigator';
import { AccessChecker } from 'authorization-scope';
import { TeamPermission } from 'nekst-api';

function LinkToExternalContactsButtonImpl() {
  const useCase = usePeopleMassLinkUseCase();

  if (useCase.isButtonVisible) {
    return (
      <Button
        text="Sync to FUB"
        isDisabled={!useCase.isButtonEnabled}
        isFlat
        isFilled
        size={ButtonSize.SMALL}
        color={ButtonColor.GRAY}
        onClick={useCase.handleAction}
      />
    );
  } else {
    return null;
  }
}

export function LinkToExternalContactsButton() {
  const peopleNavigator = usePeopleNavigator();

  return (
    <FubIntegrationToggleWrapper>
      <AccessChecker permissionToCheck={TeamPermission.MANAGE_FUB_CONNECTION}>
        <ContactNavigationContext value={{
          openNekstContact: (nekstContactId) => {
            peopleNavigator.openViewPersonPage(nekstContactId);
          },
          openExternalLink: (externalLink) => {
            window.open(externalLink, '_blank');
          },
        }}>
          <LinkToExternalContactsButtonImpl />
        </ContactNavigationContext>
      </AccessChecker>
    </FubIntegrationToggleWrapper>
  );
}
